import React, { Component } from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import classnames from "classnames"
import { Container, Row, Col, Carousel } from "react-bootstrap"
import { hexaToRgba } from "../../../components/functions"
import ButtonGroup from "../../../components/paragraph/buttons"
import Heading from "../../../components/paragraph/heading"
import Paragraph from "../../../components/paragraph/paragraphs"


export default class HeaderCarousel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: 0,
      slideCount: props.data.data.relationships.field_slide_s.length,
    }
    this.goToIndex = this.goToIndex.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  goToIndex(newIndex) {
    if (this.animating) return
    this.setState({ activeIndex: newIndex })
  }

  handleSelect() {
    if (this.animating) return
    this.goToIndex(
      this.state.activeIndex + 1 !== this.state.slideCount
        ? this.state.activeIndex + 1
        : 0
    )
  }

  render() {
    const { activeIndex } = this.state
    const slides = this.props.data.data.relationships.field_slide_s

    return (
      <Container
        className={"c_PageHeader c_PageHeader_carousel dark"}
        fluid={true}
      >
        <Carousel
          onSelect={() => {
            this.handleSelect()
          }}
          activeIndex={activeIndex}
          controls={false}
          indicators={false}
          fade={true}
          touch={true}
          interval={2000}
          className={"row"}
        >
          {slides.map((slide, index) => {
            return (
              <Carousel.Item key={index} style={{ minHeight: "400px" }}>
                <GatsbyImage
                  image={{
                    ...slide.relationships.field_image.relationships
                      .field_media_image.localFile.childImageSharp.gatsbyImageData,
                    aspectRatio: 1.25,
                  }}
                  className={"d-none d-md-block"}
                  imgStyle={{ objectFit: "cover" }}
                  alt={slide.relationships.field_image.field_media_image.alt}
                  style={{
                    marginLeft: "30%",
                    height: "100%",
                    width: "70%",
                    maxHeight: "720px",
                  }} />

                {slide.field_background_color && (
                  <div
                    className={"d-lg-none"}
                    style={{
                      backgroundColor: hexaToRgba(slide.field_background_color),
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  />
                )}
                <GatsbyImage
                  image={{
                    ...slide.relationships.field_image_overlay.relationships
                      .field_media_image.localFile.childImageSharp.gatsbyImageData,
                  }}
                  imgStyle={{ objectFit: "fill" }}
                  alt={
                    slide.relationships.field_image_overlay.field_media_image
                      .alt
                  }
                  style={{
                    position: "absolute",
                    top: 0,
                    width: "auto",
                    minWidth: "65%",
                    height: "100%",
                  }} />
                <Carousel.Caption
                  className={"text-left container"}
                  style={{
                    left: "0",
                    right: "0",
                    marginLeft: "auto",
                    marginRight: "auto",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "50px",
                  }}
                >
                  <Row>
                    <Col xs={12} md={8} lg={6}>
                      {slide.relationships.field_caption &&
                        slide.relationships.field_caption.map(
                          (caption, key) => {
                            let type
                            try {
                              type = caption.internal.type
                            } catch (e) {
                              // console.log(e)
                            }
                            switch (type) {
                              case "paragraph__component_heading":
                                return (
                                  <Heading
                                    props={caption}
                                    type={caption.field_heading_type}
                                    key={key}
                                  />
                                )
                              case "paragraph__component_paragraph_s":
                                return <Paragraph props={caption} key={key} />
                              case "paragraph__component_button_s":
                                return <ButtonGroup props={caption} key={key} />
                              default:
                                return (
                                  <p
                                    key={key}
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                      background: "white",
                                    }}
                                  >
                                    Failed to load component!
                                  </p>
                                )
                            }
                          }
                        )}
                    </Col>
                  </Row>
                </Carousel.Caption>
              </Carousel.Item>
            );
          })}

          <ol
            className="carousel-indicators container"
            style={{
              justifyContent: "left",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: "20px",
              paddingLeft: "15px",
              paddingRight: "15px",
            }}
          >
            {slides.map((_, index) => {
              return (
                <li
                  className={classnames({ active: activeIndex === index })}
                  key={index}
                  style={{
                    backgroundColor: "initial",
                    width: "auto",
                    height: "auto",
                    margin: "0",
                    padding: "0 5px",
                  }}
                >
                  <button
                    onClick={() => this.goToIndex(index)}
                    onKeyDown={() => this.goToIndex(index)}
                    aria-label="next-slide"
                    style={{
                      padding: "5px",
                      boarder: "none",
                      borderRadius: "10px",
                      float: "left",
                    }}
                  />
                </li>
              )
            })}
          </ol>
        </Carousel>
      </Container>
    );
  }
}
